import { render, staticRenderFns } from "./AutoEnableClassesButton.vue?vue&type=template&id=644faf9f&lang=pug"
import script from "./AutoEnableClassesButton.vue?vue&type=script&lang=js"
export * from "./AutoEnableClassesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports